module.exports = __webpack_public_path__ + "static/media/TimeTrain_Musical.ab9404eb.png";